<template>
    <div>
        <b-container>
            <h2 class="text-center pt-4">Deal with loneliness and overthinking during lockdown</h2>
            <div class="text-center" style="color: #A8AAB2">by <a href="http://linkedin.com/in/kanan-pathak-6575a0199" target="_Blank" style="text-decoration: none"><span class="highlight">Kanan Pathak</span></a></div> 
            <br><br>
            <center>
                <span class="card" style="background:rgba(255,255, 255, 0); border:none; border-radius:0%">
                    <img class="card-img-top" :src="depression" alt="Card image cap" style=" width: 800px;">
                </span>
            </center>
            <p class="para pt-4">
                Now in this time where the whole world is fighting against this pandemic by practicing <span class="highlight">social distancing</span>, it becomes a lot easier to feel lonely & overthink 
                and there’s nothing wrong with it because as time is becoming more challenging for us. 
                We are social animals, we need to be socially connected with people, and when we can’t connect socially, we get the feeling of loneliness and overthinking. 
            </p>
            <h4 class="text-center pt-4">Understand Loneliness</h4>
            <p class="para">
                First of all, <span class="highlight"> what is loneliness?</span>
                Loneliness is the distressing experience that occurs when one’s social relationships are perceived to be less in quantity and especially QUALITY than desired. 
                Being alone and feeling lonely are two different things. 
                Many people consider them to be the same but they're not. You can be alone without feeling lonely and can feel lonely even when you're around other people. 
            </p>
            <span class="card" style="background:rgba(255,255, 255, 0); border:none; border-radius:0%">
                <center><img class="card-img-top" :src="overthink" alt="Card image cap" style=" width: 800px;"></center>
            </span>
            <p class="para">
                Loneliness is related to depressive symptoms, lack of social support, or introvertism. 
                Loneliness changes very little during adulthood hood until 75-80 years of age when it somewhat increases. 
                Now with loneliness there comes overthinking about one’s self.
                <span class="highlight"> Overthinking</span> is the process of continuously analyzing over one’s thoughts in which one is stuck mentally in their past/present actions of their life. 
            </p>
            
            <h4 class="text-center pt-4">Overcome Loneliness</h4>
            <p class="para">
                Now the feeling of loneliness and overthinking is something which is there in everybody’s subconscious mind. 
                Even though we don’t realize that. 
                Now before these feelings take a complete toll upon us we need to stop them.
            </p>
            <span class="card" style="background:rgba(255,255, 255, 0); border:none; border-radius:0%">
                <center><img class="card-img-top" :src="depression2" alt="Card image cap" style=" width: 800px;"></center>
            </span>
            <h5 class="mt-5">1. Check on yourself:</h5>
            <p class="para2">
                The first thing is we need to address the feeling of loneliness that yes I am feeling lonely at this time and accept it. Because the first step for <span class="highlight"> growth is acceptance.</span> 
            </p> <br>
            <h5>2. Talk with someone: </h5>
            <p class="para2">
                The second thing you can do is that if you have a <span class="highlight">sibling</span> (any other family member or a friend) or 
                someone with whom you easily connect & talk freely and tell them what and how are you feeling.
            </p> <br>
            <h5>3. Note your thoughts:</h5>
            <p class="para2">
                If you are an <span class="highlight">introvert</span> who feels uncomfortable sharing their feelings with someone, 
                you can write in a book about what kind of thoughts are running in your mind and you can write whatever thought comes first. 
                Because when you write what you are feeling and your thoughts you can get clarity about your feeling and yourself.
            </p> <br>
            <h5>4. Slam yourself</h5>
            <p class="para2">
                The moment you feel like overthinking is hitting you, just say <span class="highlight">STOP IT</span> aloud and force your mind to do something else, 
                until that thought is no longer running in your head. 
            </p> <br>   
            <h5>5. Distraction is the key: </h5>
            <p class="para2">
                Distract yourself by reading a book/listening to music/ watching a movie or whatever makes you feel happy about it.
            </p> <br>


            <h4 class="text-center pt-4">Let's talk beyond loneliness</h4>
            <p class="para">
                During the day-time, we feel less lonely and don’t overthink much since we are surrounded by family members and busy with our work. 
                But at night our mind goes into ideal state and starts to overthink, feel lonely & miserable about ourselves most of the time, 
                at that moment you don’t have anyone to share your thoughts so what you can do is, 
                you can just <span class="highlight">talk to yourself</span> like you are talking to your friend on a call or imagine a friend sitting beside you and 
                talk about what you are thinking so when those thoughts are out from your mouth they will be automatically out of your mind because they are released from your mind. 
                Sometimes people also zone out and just keep looking somewhere constantly without even realizing where they're & what they're thinking.
                <span class="highlight">Zoning out is the key symptom of loneliness and overthinking</span> because we feel that there is a lack of peace in reality that we go out of reality.
                Now during this time most people don’t want to surround themselves with negativity, but sub-consciously they zone out. 
            </p>
            <span class="card" style="background:rgba(255,255, 255, 0); border:none; border-radius:0%">
                <center><img class="card-img-top" :src="smile" alt="Card image cap" style=" width: 800px;"></center>
            </span>
            <p class="para mt-5">
                Now coming back to <span class="highlight">overthinking</span>. 
                The main reason for overthinking at night during lockdown is we don’t sleep at night and keep encouraging that thought to grow. 
                To avoid overthinking we need to sleep at night so that we don’t encourage any thought. 
                As per human need, we need a minimum of 7-9 hours of sleep at night because sleep helps us to recover from mental as well as physical exertion. 
            </p>
            <h4 class="text-center pt-4">Heal from mental pressure</h4>
            <p class="para">
                Many people think that <i>I am not doing anything productive during this lockdown</i>. <b>Remember, this is not a productive competition do what you feel like</b>. 
                Try to do one self-care routine daily like writing down a small gratification note about what made you happy today or what you did that made you happy, 
                watching a movie/stand up comedy, dancing your heart out, taking a good long shower, doodling, making chai/coffee for yourself in the evening, you can do a little exercise for yourself like suryanamaskar/cardio/or small and simple exercise to do any time of the day. 
                Because exercise is important for a healthy mind. 
            </p>
            <h5 class="pt-4 highlight text-center">NOTE :- You are perfect at whatever you are doing. Everyone is in the right place.</h5>
        </b-container>
    </div>
</template>

<script>
    import depression from '../assets/Blog/depression.jpg'
    import depression2 from '../assets/Blog/home.jpg'
    import overthink from '../assets/Blog/overthink.jpg'
    import smile from '../assets/Blog/happy.jpg'
    export default {
        name: 'blog',
        data: () => ({
            depression,
            depression2,
            overthink,
            smile
        })
    }
</script>

<style scoped>
    /* .header{
        font-size: 28px;
        font-family: "Roboto", sans-serif;
    }
    @media (max-width: 667px) {
        .header{
            font-size: 16px;
        }
    } */
    .para{
    font-size: 16px;   
    margin-top: 22px;
    margin-bottom: 32px;
    word-spacing: 2px;
    }
    .para2{
        font-size: 16px;   
        margin-top: 16px;
        margin-bottom: 26px;
        word-spacing: 2px;
    }
    .highlight{
        color: #0fc1a7;
        font-weight: 500;
    }
</style>